import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeIn } from './ui/Section';
import { ShoppingBag, Briefcase, FileText, MessageSquare, CheckCircle } from 'lucide-react';
export function IncludesSection() {
  const categories = [{
    title: 'Vida Diaria',
    icon: ShoppingBag,
    items: ['Coffee shop', 'Súper', 'Gym', 'Vecinos', 'Direcciones', 'Returns', 'Barber']
  }, {
    title: 'Trabajo',
    icon: Briefcase,
    items: ['Entrevista', 'Primer día', 'Pedir ayuda', 'Chat', 'Desacuerdos suaves', 'Días libres', 'Customer service']
  }, {
    title: 'Trámites / Urgencias',
    icon: FileText,
    items: ['DMV', 'Doctor/Farmacia', 'Escuela', 'Renta', 'Banco']
  }, {
    title: 'Social / Texting',
    icon: MessageSquare,
    items: ['Planes', 'Cancelar', 'Small talk', 'Dating light', 'Límites', 'Malentendidos']
  }];
  return <Section data-id="element-203">
      <div className="text-center mb-16" data-id="element-204">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-205">
          Qué incluye (lo que recibes)
        </h2>
        <p className="text-lg text-slate-600" data-id="element-206">
          Un sistema completo para desbloquear tu habla en cualquier situación.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-207">
        {categories.map((cat, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-208">
            <div className="flex items-center mb-6" data-id="element-209">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-4 text-blue-600" data-id="element-210">
                <cat.icon className="w-5 h-5" data-id="element-211" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-212">{cat.title}</h3>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-213">
              {cat.items.map(item => <span key={item} className="bg-white px-3 py-1 rounded-full text-sm text-slate-600 border border-slate-200 shadow-sm" data-id="element-214">
                  {item}
                </span>)}
            </div>
          </motion.div>)}
      </div>

      <div className="bg-[#003366] text-white rounded-3xl p-8 md:p-12" data-id="element-215">
        <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-216">
          También incluye:
        </h3>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-217">
          {['Inglés + traducción al español', 'Pronunciación simple (fonética latina)', 'Sección de pronunciación útil + ritmo + fillers nativos', '“Errores de latino que te delatan” con reemplazos exactos', 'Plan de mantenimiento 7 minutos/día'].map((feature, idx) => <div key={idx} className="flex items-start" data-id="element-218">
              <CheckCircle className="w-6 h-6 text-[#FF6600] mr-3 flex-shrink-0" data-id="element-219" />
              <span className="text-slate-200" data-id="element-220">{feature}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}